import { useMemo } from 'react';
import { useRegisterRoute } from './useRegisterRoute';
import { type TicketData } from '@/api/registration';
import { useGroupCartQuery } from './useGroupCartQuery';

interface GroupInStockItem {
  isInStock: boolean
  totalSharedStockInCart: number
  tempRegistrationIds: number[]
}

export function useGroupInStockItem(
  ticket: TicketData,
  sharedTicketIds: number[]
): GroupInStockItem {
  const { eventId } = useRegisterRoute();

  const { data: cart } = useGroupCartQuery(eventId);

  const result = useMemo(() => {
    if (!cart?.cartItems || !ticket.ticketSharedStockId) {
      return {
        isInStock: false,
        totalSharedStockInCart: 0,
        tempRegistrationIds: [],
      };
    }

    const sharedStockItems = cart.cartItems.filter((item) => {
      return (
        item.ticketType === ticket.type &&
        sharedTicketIds.includes(item.productId)
      );
    });

    const totalSharedStockInCart = sharedStockItems.reduce(
      (acc, { tempRegistrationIds }) => {
        if (!tempRegistrationIds) {
          return acc;
        }
        return acc + tempRegistrationIds.length;
      },
      0
    );

    const isInStock = ticket.currentStock > totalSharedStockInCart;

    const tempRegistrationIds = sharedStockItems.flatMap((item) => {
      return item.tempRegistrationIds ?? [];
    });
    return {
      isInStock,
      totalSharedStockInCart,
      tempRegistrationIds,
    };
  }, [
    cart?.cartItems,
    ticket.ticketSharedStockId,
    ticket.currentStock,
    ticket.type,
    sharedTicketIds,
  ]);

  return result;
}
